import type { AnalysisResult } from '../types';

/**
 * Filters posture analysis metrics by experimental feature setting.
 * - Angle-based metrics (unit '°') are always shown.
 * - Distance-based metrics (unit 'cm' or 'inches') are only shown when experimental features are enabled.
 */
export function filterMetricsByExperimental(
  results: AnalysisResult[],
  experimentalEnabled: boolean
): AnalysisResult[] {
  if (experimentalEnabled) return results;
  return results.filter((r) => r.unit === '°' || r.unit === '');
}
